import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertWebpToIco() {
  return (
    <ImageConverterTemplate
      sourceFormat="WebP"
      targetFormat="ICO"
      acceptTypes=".webp,image/webp"
      slug="convert-webp-to-ico"
      gradientColors="from-green-500 to-cyan-500"
      accentColor="cyan"
    />
  );
}
